import { IconProps } from "../../types/utils";

const Lock = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 32}
    height={dimension || 32}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.5248 14.5326H21.208V11.8287C21.208 10.439 20.6673 9.13349 19.6857 8.15099C18.7048 7.16937 17.3983 6.62866 16.008 6.62866C13.1408 6.62866 10.808 8.96151 10.808 11.8287V14.5326H10.4912C9.64641 14.5326 8.95996 15.219 8.95996 16.0638V23.8174C8.95996 24.6622 9.64641 25.3487 10.4912 25.3487H21.5239C22.3687 25.3487 23.0551 24.6622 23.0551 23.8174V16.0638C23.0559 15.219 22.3685 14.5326 21.5246 14.5326H21.5248ZM12.408 11.8287C12.408 9.84384 14.0232 8.22866 16.008 8.22866C16.9703 8.22866 17.8751 8.60313 18.5544 9.28224C19.2344 9.96224 19.608 10.8655 19.608 11.8287V14.5326H12.408V11.8287ZM21.4562 23.7487H10.5602V16.1327H21.4562V23.7487Z"
      fill={color || "#242424"}
    />
  </svg>
);

export default Lock;
